import React from 'react';

import FormContainer from '../../utils/FormContainer/FormContainer';
import { useSelector } from 'react-redux';
import { selectRSVPInfo } from '../../../store/slice/rsvp/slice';

import { Message, Title, TitleContainer } from './RsvpSubmitted.styles';

const RsvpSubmitted = () => {
  const rsvp = useSelector(selectRSVPInfo);

  return (
    <>
      <FormContainer gap>
        <TitleContainer>
          <Message>{`Hey there!`}</Message>
          <Message>{`It looks like you have already submitted your RSVP. If you need to make a change, please contact your event host directly.`}</Message>
          <Message>{`Thank you!`}</Message>
        </TitleContainer>
        <Title>{`${rsvp.brideName} & ${rsvp.groomName}!`}</Title>
      </FormContainer>
    </>
  );
};

export default RsvpSubmitted;
